import React, { useEffect, useState } from "react";
import { AppNotification, notificationService } from "../services/notificationService";

// Inline notification stack anchored to the top of the page content area. It
// sticks to the top of the scroll container (rather than floating in a screen
// corner) so messages stay in the user's reading context.
export const NotificationBanner = () => {
  const [notifications, setNotifications] = useState<AppNotification[]>(() =>
    notificationService.getAll()
  );

  useEffect(() => notificationService.onUpdate(setNotifications), []);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notif-stack" role="region" aria-label="Notifications" aria-live="polite">
      {notifications.map((notification) => (
        <div key={notification.id} className={`notif notif--${notification.type}`} role="alert">
          <span className="notif-icon" aria-hidden="true">
            {notification.type === "warning" && "⚠"}
            {notification.type === "error" && "✕"}
            {notification.type === "success" && "✓"}
            {notification.type === "info" && "ℹ"}
          </span>
          <span className="notif-message">{notification.message}</span>
          <div className="notif-actions">
            {notification.action && (
              <button
                className="notif-action-btn"
                type="button"
                onClick={notification.action.onClick}
              >
                {notification.action.label}
              </button>
            )}
            <button
              className="notif-dismiss-btn"
              type="button"
              aria-label="Dismiss"
              onClick={() => notificationService.dismiss(notification.id)}
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
